const selectDropDownInitialState = {
    selectDropDown: {
        selectGlobal: {
            pacienteElegido: false,
        },
        consulMedica: {
            pacienteElegido: false,
        },
        estudios: {
            pacienteElegido: false,
        },
        laboratorio: {
            pacienteElegido: false,
        }, 
        recetaDigital: {
            pacienteElegido: false,
        },
        misLaboratorios: {
            pacienteElegido: false,
        },
        misInformes: {
            pacienteElegido: false,
        }, 
        proximosTurnos : {
            pacienteElegido: false, 
        },
        misMedicos: {
            pacienteElegido: false,
            especialistas: null,
        }
    }
}

export default  selectDropDownInitialState;